import { Centered, EmptyState, FlexColumn, useLoading } from '@gorila-shared-ui/components';
import { LoadingSpinner } from 'baseui/button/styled-components';
import { useEffect, useState } from 'react';
import { useRecoilValue } from 'recoil';
import { useFeedback } from '../../../hooks/useFeedback';
import { useStyles } from '../../../hooks/useStyles';
import { getIntegrationLogs } from '../../../services/integrationService';
import { apiParamsState } from '../../../storage/app';
import { IntegrationLog } from '../../../types/integrations';
import IntegrationLogDetail from './IntegrationLogDetail';

type Props = {
  integrationId: string;
};

function IntegrationLogs({ integrationId }: Readonly<Props>) {
  const { loading, startLoading, stopLoading } = useLoading(true);
  const { showFailFeedback } = useFeedback();
  const { theme } = useStyles();
  const [logs, setLogs] = useState<IntegrationLog[]>();
  const apiParams = useRecoilValue(apiParamsState);

  useEffect(() => {
    if (!apiParams?.clientId || !apiParams.subClientId) {
      stopLoading();
      return;
    }
    const loadLogs = async () => {
      startLoading();
      const { logs, error } = await getIntegrationLogs(apiParams.clientId, apiParams.subClientId, integrationId);
      if (!error && logs) {
        setLogs(logs);
      } else if (error) {
        showFailFeedback(error);
      }
      stopLoading();
    };

    loadLogs();
  }, [integrationId, apiParams?.clientId, apiParams?.subClientId]);

  if (loading) {
    return (
      <Centered>
        <LoadingSpinner />
      </Centered>
    );
  }

  if (!logs?.length) {
    return <EmptyState description="No existen logs dentro de esta integración" />;
  }

  return (
    <FlexColumn gap={theme.sizing.scale400}>
      {logs.map((log) => (
        <IntegrationLogDetail
          key={log._id}
          log={log}
        />
      ))}
    </FlexColumn>
  );
}

export default IntegrationLogs;
